var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_702_22896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68651 1.50357C3.00725 1.47973 3.28658 1.72042 3.31041 2.04115L3.40637 3.33244C5.58146 2.97473 7.78405 2.81106 9.98813 2.84334L9.89217 1.55205C9.86834 1.23132 10.109 0.951987 10.4298 0.928153C10.7505 0.904319 11.0298 1.145 11.0537 1.46574L11.1582 2.87225C12.3264 2.94981 13.3077 3.79635 13.549 4.95128L13.6536 5.4519C14.0935 7.5575 14.2294 9.71528 14.0571 11.8594C13.9717 12.9216 13.1786 13.7915 12.1288 13.9744L11.2118 14.1341C8.78668 14.5566 6.32588 14.7395 3.86494 14.6801L2.9344 14.6576C1.86912 14.6319 0.95615 13.8888 0.714731 12.8509C0.227387 10.7558 0.0428276 8.60163 0.166682 6.45414L0.196129 5.94356C0.264064 4.76564 1.10947 3.78333 2.25344 3.53397L2.14892 2.12747C2.12509 1.80673 2.36578 1.5274 2.68651 1.50357ZM3.25866 4.53871C5.58705 4.13309 7.9497 3.95752 10.3125 4.01453L11.0187 4.03157C11.6948 4.04788 12.2706 4.5275 12.4089 5.18947L12.5135 5.69009C12.5501 5.86498 12.5844 6.04025 12.6165 6.21586L1.30531 7.05641C1.31111 6.87799 1.31915 6.69957 1.32944 6.5212L1.35889 6.01062C1.39782 5.33548 1.89646 4.77601 2.56269 4.65995L3.25866 4.53871ZM1.29929 8.22476C1.33191 9.69239 1.51586 11.1543 1.84914 12.5871C1.97023 13.1076 2.42816 13.4804 2.96249 13.4933L3.89304 13.5157C6.2776 13.5733 8.66205 13.3961 11.0119 12.9867L11.9289 12.827C12.4555 12.7352 12.8533 12.2989 12.8961 11.7661C13.0139 10.2998 12.9798 8.82682 12.7951 7.37048L1.29929 8.22476Z",
    fill: "#242833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_702_22896",
    x: -3.87067,
    y: -3.07324,
    width: 22.0001,
    height: 21.7642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_702_22896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_702_22896",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteIcon);
export default __webpack_public_path__ + "static/media/site_icon.fa965f13fde4987b546732516b423782.svg";
export { ForwardRef as ReactComponent };